import { defineMessages } from 'react-intl';

export const messages: {
	foundIn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	similar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	related: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionedIn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	comments: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	relatedPages: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	seeAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	foundIn: {
		id: 'search-page.linked-results.found-in',
		defaultMessage: 'Found in',
		description: 'Label to indicate where the linked result was found',
	},
	similar: {
		id: 'search-page.linked-results.similar',
		defaultMessage: '{count} similar',
		description:
			'Label shown in the linked results section indicating how many similar items exist. The placeholder {count} is substituted with the number of similar results.',
	},
	related: {
		id: 'search-page.linked-results.related',
		defaultMessage: 'Related links',
		description:
			'Section heading shown in the linked results panel for related external links associated with a search result.',
	},
	mentionedIn: {
		id: 'search-page.linked-results.mentioned-in',
		defaultMessage: 'Mentioned in',
		description:
			'Label for mentioned-by linked results showing where a document has been mentioned',
	},
	comments: {
		id: 'search-page.linked-results.comments',
		defaultMessage: 'Comments',
		description: 'Label for embedded comments that matched a search query within a document',
	},
	relatedPages: {
		id: 'search-page.linked-results.related-pages',
		defaultMessage: 'Related pages',
		description:
			'Label for related pages (child linked results under Confluence directory or empty file)',
	},
	showMore: {
		id: 'search-page.linked-results.show-more',
		defaultMessage: 'Show {count} more',
		description:
			'Button label in the linked results panel that expands to show additional results. The placeholder {count} is substituted with the number of hidden results.',
	},
	seeAll: {
		id: 'search-page.linked-results.see-all',
		defaultMessage: 'See all',
		description: 'Button text to see all linked results on the full page',
	},
	externalLink: {
		id: 'search-page.linked-results.external-link',
		defaultMessage: 'External link',
		description:
			'Accessible label for the external link icon shown next to linked results that point to pages outside the current product.',
	},
});
